import Image from "next/image";
import CommonImage from "@/components/common/image/CommonImage";
import { LuClock5 } from "react-icons/lu";
import Link from "next/link";

export default function CourseCard({ course }) {
  return (
    <div className="course-item">
      <div className="course-image">
        {/* <CommonImage
          src={course?.thumbnail_url ?? "/images/course-img/thumbnail-1.avif"}
          className="thumbnail !h-full"
          alt="Course Thumbnail"
        /> */}
        <Image
          src={course?.thumbnail_url ?? "/images/course-img/thumbnail-1.avif"}
          alt="Course Thumbnail"
          className="arrow-icon w-full h-full"
          width={0}
          height={0}
          sizes="100vw"
        />
      </div>
      <div className="item-content">
        <span className="course-timer">
          <LuClock5 className="icon" />
          {course?.status_bn}
        </span>
        <h4 className="title">
          {" "}
          {course?.title?.length > 60
            ? `${course.title.slice(0, 60)}...`
            : course?.title}
        </h4>
        <Link href={`/course/${course?.slug}`} className="primary-btn">
          বিস্তারিত দেখো
          <Image
            src={"/images/header-footer/arrow-right.avif"}
            alt="Arrow Right"
            className="arrow-icon"
            width={16}
            height={16}
          />
        </Link>
      </div>
    </div>
  );
}
